/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CalculationParameterEntryParam
 */
export interface CalculationParameterEntryParam {
    /**
     * 
     * @type {string}
     * @memberof CalculationParameterEntryParam
     */
    id: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CalculationParameterEntryParam
     */
    effectiveFrom: Date | null;
    /**
     * 
     * @type {number}
     * @memberof CalculationParameterEntryParam
     */
    value: number;
}

/**
 * Check if a given object implements the CalculationParameterEntryParam interface.
 */
export function instanceOfCalculationParameterEntryParam(value: object): value is CalculationParameterEntryParam {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('effectiveFrom' in value) || value['effectiveFrom'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function CalculationParameterEntryParamFromJSON(json: any): CalculationParameterEntryParam {
    return CalculationParameterEntryParamFromJSONTyped(json, false);
}

export function CalculationParameterEntryParamFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculationParameterEntryParam {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'effectiveFrom': (json['effectiveFrom'] == null ? null : new Date(json['effectiveFrom'])),
        'value': json['value'],
    };
}

export function CalculationParameterEntryParamToJSON(json: any): CalculationParameterEntryParam {
    return CalculationParameterEntryParamToJSONTyped(json, false);
}

export function CalculationParameterEntryParamToJSONTyped(value?: CalculationParameterEntryParam | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'effectiveFrom': value['effectiveFrom'] == null ? value['effectiveFrom'] : `${value['effectiveFrom'].getFullYear()}-${String(value['effectiveFrom'].getMonth()+1).padStart(2,'0')}-${String(value['effectiveFrom'].getDate()).padStart(2,'0')}`,
        'value': value['value'],
    };
}

